"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.contextMenu = void 0;

var _polished = require("polished");

var _color = _interopRequireDefault(require("../choices/color.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _zIndex = _interopRequireDefault(require("../choices/zIndex.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var contextMenu = {
  contextMenuBackground: _color["default"].white,
  contextMenuBorder: "1px solid ".concat(_color["default"].cloudyBlue300),
  contextMenuBoxShadow: "0px 1px 5px ".concat((0, _polished.rgba)(_color["default"].pickledBluewood800, 0.1)),
  contextMenuFontFamily: _font["default"].family,
  contextMenuFontSize: _font["default"].sizeSm,
  contextMenuZIndex: _zIndex["default"].z1000,
  contextMenuItemColor: _color["default"].pickledBluewood800,
  contextMenuItemWidth: "246px",
  contextMenuItemHoverColor: _color["default"].dodgerBlue100,
  contextMenuItemDisabledHoverColor: 'transparent'
};
exports.contextMenu = contextMenu;
var _default = contextMenu;
exports["default"] = _default;